// extracted by css-extract-rspack-plugin
export default {"page":"src-pages-manage-PathPresenterImportPage-module__page-oXMoqb","crumb":"src-pages-manage-PathPresenterImportPage-module__crumb-RQ1vq7","widget":"src-pages-manage-PathPresenterImportPage-module__widget-wsNN09"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"page\":\"src-pages-manage-PathPresenterImportPage-module__page-oXMoqb\",\"crumb\":\"src-pages-manage-PathPresenterImportPage-module__crumb-RQ1vq7\",\"widget\":\"src-pages-manage-PathPresenterImportPage-module__widget-wsNN09\"}";
        // 1793732399055
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  